
import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class ReservationFooter extends Vue {
	@Prop({
		required: true,
		type: Boolean,
	})
	public isFree?: boolean;

	public specificSubject = 'ein Sitzungszimmer';
	public noNameUrl = 'https://www.raumkalender.com/referer?utm_medium=website&utm_source=app-free-noname&utm_campaign=raumkalenderapp';
	public withNameUrl = 'https://www.raumkalender.com/referer?utm_medium=website&utm_source=app-free-noname&utm_campaign=raumkalenderapp';

	public mounted() {
		let calendarSubjects = [
			'ein Sitzungszimmer',
			'eine Ferienwohnung',
			'ein Ferienhaus',
			'einen Raum',
			'einen Platz',
			'ein Lokal',
			'eine Halle',
			'einen Gegenstand'
		];

		this.specificSubject = calendarSubjects[Math.floor(Math.random()*calendarSubjects.length)]
		this.noNameUrl = 'https://www.raumkalender.com?utm_medium=website&utm_source=app-free-withname&utm_campaign=raumkalenderapp&utm_content=' + this.specificSubject;
		this.withNameUrl = 'https://www.raumkalender.com?utm_medium=website&utm_source=app-free-noname&utm_campaign=raumkalenderapp&utm_content=' + this.specificSubject;
	}

}
